export default "/_next/static/data/the-omnichannel-imperative-lottie.json-2e65eb4e439d6156a77e4ea30e8e6fe3.json";